<script>
import { mapActions } from 'vuex'

export default {
  data: () => ({}),

  computed: {},

  methods: {
    ...mapActions('auth', ['login'])
  },

  async mounted() {
    await this.login()
  }
}
</script>
